import React, { useContext } from 'react';
import { ButtonComp } from 'atoms/Buttons';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { startOrderButtonClickHandler, modifyAddressSpacing } from '../SearchStoreUtilities/SearchStoreUtils';
import { UserOrderContext } from 'context/context';
import SEARCH_STORE_CONSTANTS from 'organisms/SearchStore/AU/Constants/SearchStoreConstants';
import { setPWAstorage, } from '@kfc-global/react-shared/redux/Slices/PwaStorageSlice';
import { useAppDispatch } from '@kfc-global/react-shared/redux/Store/hooks';

const { SAVED_ADDRESS, START_ORDER, SAVED_ADDRESSES } = TRANSLATE_MAPPING_KEY;
const { SAVED_ADDRESS_LIMIT } = SEARCH_STORE_CONSTANTS;

const SavedAddressViewComp = props => {
  const dispatch = useAppDispatch();
  const { handleSelectAddress, savedAddresses = [], show } = props;
  const { userOrderStateDispatch } = useContext(UserOrderContext);
  const savedAddrData = savedAddresses?.sort((a, b) => b?.isPrimary - a?.isPrimary).slice(0, SAVED_ADDRESS_LIMIT);
  const savedAddrText =
    savedAddresses?.length > 1 ? translateWithI18Next(SAVED_ADDRESSES) : translateWithI18Next(SAVED_ADDRESS);
  const savedAddrLength = savedAddresses?.length > SAVED_ADDRESS_LIMIT ? SAVED_ADDRESS_LIMIT : savedAddresses.length;

  return (
    (show && (
      <div data-testid='saved-address-container'>
        <div className='savedAddress-store-count'>
          <span className='saved-address-count-title'>{`${savedAddrText} (${savedAddrLength})`}</span>
        </div>
        {savedAddrData?.map((savedAddress, index) => {
          return (
            <div key={`${savedAddress?.name}-${index}`} className='savedAddress-module-card'>
              <div className='inside-card'>
                <div className='address-section'>
                  <div className='address-type'>{savedAddress?.name}: </div>
                  <div className='address'>
                    {savedAddress?.addressLines[0] && (
                      <span> {modifyAddressSpacing(savedAddress?.addressLines[0])}, </span>
                    )}
                    {savedAddress?.addressLines[1] && (
                      <span> {modifyAddressSpacing(savedAddress?.addressLines[1])}, </span>
                    )}
                    {savedAddress?.city && <span> {savedAddress?.city}, </span>}
                    {savedAddress?.state && <span> {savedAddress?.state} - </span>}
                    {savedAddress?.pinCode && <span> {savedAddress?.pinCode}, </span>}
                    {savedAddress?.country && <span> {savedAddress?.country} </span>}
                  </div>
                </div>
                <div>
                  <ButtonComp
                    className='button redButton search-store-card-btn'
                    onClickHandler={() =>
                      startOrderButtonClickHandler(savedAddress, userOrderStateDispatch, handleSelectAddress, dispatch, setPWAstorage)
                    }
                    data-testid='saved-start-order-click-test'
                  >
                    {translateWithI18Next(START_ORDER)}
                  </ButtonComp>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    )) ||
    null
  );
};

const SavedAddressView = React.memo(SavedAddressViewComp);
export default SavedAddressView;
